import { fetchDocument as i, prettyPrintJson as f } from "@scalar/oas-utils/helpers";
import { ref as s, watch as m, toValue as u } from "vue";
function l({
  configuration: r
}) {
  const t = s("");
  return m(
    () => u(r),
    async (n) => {
      var e, o;
      if (!n)
        return;
      const c = await a(n, (e = u(r)) == null ? void 0 : e.proxyUrl, (o = u(r)) == null ? void 0 : o.fetch);
      typeof c == "string" && (t.value = c.trim());
    },
    { immediate: !0, deep: !0 }
  ), {
    originalDocument: t
  };
}
const a = async ({ url: r, content: t }, n, c) => {
  if (r && !t)
    try {
      return await i(r, n, c);
    } catch (o) {
      console.error("Failed to fetch OpenAPI document from URL:", o);
    }
  const e = typeof t == "function" ? t() : t;
  if (typeof e == "string")
    return e;
  if (typeof e == "object")
    return f(e);
};
export {
  l as useDocumentFetcher
};
